export const MODEL_ROUTE = '/prescription-fills';
